module.exports = __webpack_public_path__ + "static/media/filter.3868bcdb.svg";